import { useEffect, useState } from "react";
import { Droppable } from "react-beautiful-dnd";

/**
 * StrictModeDroppable component
 * Fixes react-beautiful-dnd compatibility issues with React 18 Strict Mode
 */
export const StrictModeDroppable = ({ children, ...props }) => {
  const [enabled, setEnabled] = useState(false);

  /**
   * This handles the setting of the strict mode droppable
   */
  useEffect(() => {
    const animation = requestAnimationFrame(() => setEnabled(true));
    return () => {
      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);

  if (!enabled) {
    return null;
  }

  return <Droppable {...props}>{children}</Droppable>;
};
